module.exports = __webpack_public_path__ + "img/email.885d1806.svg";